/**
 * Small Text / HTML toggle used in every email composer.
 *
 * Renders a pill toggle with two buttons. When the user flips modes we DON'T
 * just swap the editor's syntax — we also convert the underlying body string
 * (text → HTML wrapping in <p>, HTML → text by stripping tags) so the editor
 * never shows raw markup the user didn't put there themselves.
 */
import React from 'react';
import { Code, Type } from 'lucide-react';
import { textToHtml, htmlToText } from '../lib/emailEditor';

export const EmailModeToggle = ({ mode, onChange, body, setBody, testIdPrefix = 'editor-mode' }) => {
  const handleToggle = (next) => {
    if (next === mode) return;
    if (next === 'text') setBody(htmlToText(body || ''));
    else setBody(textToHtml(body || ''));
    onChange(next);
  };
  return (
    <div
      className="flex items-center gap-0.5 bg-slate-200 rounded-md p-0.5"
      data-testid={`${testIdPrefix}-toggle`}
    >
      <button
        type="button"
        onClick={() => handleToggle('text')}
        className={`flex items-center gap-1 px-2.5 py-1 rounded text-xs font-medium transition-all ${
          mode === 'text' ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700'
        }`}
        data-testid={`${testIdPrefix}-text`}
      >
        <Type className="w-3.5 h-3.5" />
        Text
      </button>
      <button
        type="button"
        onClick={() => handleToggle('html')}
        className={`flex items-center gap-1 px-2.5 py-1 rounded text-xs font-medium transition-all ${
          mode === 'html' ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700'
        }`}
        data-testid={`${testIdPrefix}-html`}
      >
        <Code className="w-3.5 h-3.5" />
        HTML
      </button>
    </div>
  );
};

export default EmailModeToggle;
